import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { trpc } from "@/lib/trpc";
import { formatarData, diaDaSemana } from "@/lib/utils";

export function ModalCriarTurno({
  dataIso,
  open,
  onOpenChange,
  onCreated,
}: {
  dataIso: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onCreated: () => void;
}) {
  const profissionaisQ = trpc.profissionais.listar.useQuery({ incluirInativos: false });
  const tiposQ = trpc.tiposTurno.listar.useQuery();
  const criar = trpc.turnos.criar.useMutation();

  const [profissionalId, setProfissionalId] = useState<string>("");
  const [tipoTurnoId, setTipoTurnoId] = useState<string>("");
  const [observacoes, setObservacoes] = useState("");
  const [forceOverride, setForceOverride] = useState(false);

  async function submit() {
    if (!profissionalId || !tipoTurnoId) return;
    const result = await criar.mutateAsync({
      profissionalId: Number(profissionalId),
      tipoTurnoId: Number(tipoTurnoId),
      data: dataIso,
      observacoes: observacoes || undefined,
      forceOverride,
    });
    if (result.warning && !forceOverride) {
      const ok = confirm(`Atenção: ${result.warning}. ${result.motivo ?? ""} Confirmar mesmo assim?`);
      if (ok) {
        await criar.mutateAsync({
          profissionalId: Number(profissionalId),
          tipoTurnoId: Number(tipoTurnoId),
          data: dataIso,
          observacoes: observacoes || undefined,
          forceOverride: true,
        });
      } else {
        return;
      }
    }
    onCreated();
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Novo turno</DialogTitle>
          <DialogDescription>
            {diaDaSemana(dataIso, true)}, {formatarData(dataIso)}
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div className="space-y-1.5">
            <Label>Profissional</Label>
            <Select value={profissionalId} onValueChange={setProfissionalId}>
              <SelectTrigger><SelectValue placeholder="Selecione..." /></SelectTrigger>
              <SelectContent>
                {(profissionaisQ.data ?? []).map((p) => (
                  <SelectItem key={p.id} value={String(p.id)}>{p.nome}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <div className="space-y-1.5">
            <Label>Tipo de turno</Label>
            <Select value={tipoTurnoId} onValueChange={setTipoTurnoId}>
              <SelectTrigger><SelectValue placeholder="Selecione..." /></SelectTrigger>
              <SelectContent>
                {(tiposQ.data ?? []).map((t) => (
                  <SelectItem key={t.id} value={String(t.id)}>{t.nome}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <div className="space-y-1.5">
            <Label>Observações</Label>
            <Input
              value={observacoes}
              onChange={(e) => setObservacoes(e.target.value)}
              placeholder="Opcional"
            />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancelar</Button>
          <Button onClick={submit} disabled={criar.isPending || !profissionalId || !tipoTurnoId}>
            {criar.isPending ? "Salvando..." : "Salvar"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
